import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import * as api from '../api/global';

const namespace = 'QUEUE';

export const PREFERENCE_FETCH = createRequestTypes(
  `${namespace}/PREFERENCE_FETCH`,
);

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH[START],
  PREFERENCE_FETCH[SUCCESS],
  PREFERENCE_FETCH[ERROR],
);

export const PREFERENCE_PERSIST = createRequestTypes(
  `${namespace}/PREFERENCE_PERSIST`,
);

export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST[START],
  PREFERENCE_PERSIST[SUCCESS],
  PREFERENCE_PERSIST[ERROR],
);

export const UPLOAD_FILE = createRequestTypes(`${namespace}/UPLOAD_FILE`);

export const uploadFile = makeApiActionCreatorV3(
  api.uploadFile,
  UPLOAD_FILE[START],
  UPLOAD_FILE[SUCCESS],
  UPLOAD_FILE[ERROR],
);

export const DOWNLOAD_FILE = createRequestTypes(`${namespace}/DOWNLOAD_FILE`);

export const downloadFile = makeApiActionCreatorV3(
  api.downloadFile,
  DOWNLOAD_FILE[START],
  DOWNLOAD_FILE[SUCCESS],
  DOWNLOAD_FILE[ERROR],
);

export const SELECT_QUEUE = `${namespace}/SELECT_QUEUE`;

export const selectQueue = queue => ({
  type: SELECT_QUEUE,
  queue,
});

export const SELECT_QUEUE_WORK_ITEM = `${namespace}/SELECT_QUEUE_WORK_ITEM`;

export const selectQueueWorkItem = queueWorkItem => ({
  type: SELECT_QUEUE_WORK_ITEM,
  queueWorkItem,
});

export const RESET_ACTIVE_WORK_ITEM = `${namespace}/RESET_ACTIVE_WORK_ITEM`;

export const resetActiveRecords = () => ({
  type: RESET_ACTIVE_WORK_ITEM,
});
